// c:\React-Next\EventHouse\eventhouse\frontend\src\components\Upcommingexprences.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Upcommingexprences.css";
import coldImg from "../assets/images/cold.png";
import arrowImg from "../assets/images/arrow.png";

import { Navigation, Autoplay } from "swiper/modules";
import SwiperCore from "swiper";
SwiperCore.use([Navigation, Autoplay]);

const Upcommingexprences = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  const truncateWords = (value, limit) => {
    if (!value) return "";
    const words = value.trim().split(/\s+/);
    if (words.length <= limit) return words.join(" ");
    return `${words.slice(0, limit).join(" ")}...`;
  };

  useEffect(() => {
    let isMounted = true;
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const loadEvents = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/public/events`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Failed to load events");
        }

        const items = Array.isArray(data.events) ? data.events : [];
        const mapped = items.map((item) => {
          const eventDate = item?.date ? new Date(item.date) : null;
          const dateNumber =
            eventDate && !Number.isNaN(eventDate.getTime())
              ? String(eventDate.getDate()).padStart(2, "0")
              : "--";
          const monthLabel =
            eventDate && !Number.isNaN(eventDate.getTime())
              ? eventDate
                  .toLocaleString("en-US", { month: "short" })
                  .toUpperCase()
              : "";
          const cityLabel =
            item.city ||
            [item.city, item.state, item.country].filter(Boolean).join(", ") ||
            "city TBA";
          const rawThumbnail = item.thumbnail || "";
          const normalizedThumbnail = rawThumbnail
            ? rawThumbnail.replace(
                /^https?:\/\/localhost(:\d+)?/i,
                API_BASE_URL,
              )
            : "";
          return {
            id: item._id,
            date: dateNumber,
            month: monthLabel,
            title: truncateWords(item.title || "EVENT", 2),
            city: truncateWords(cityLabel, 3),
            time: item.time || "05:00 PM Onwards",
            description: item.shortDescription || item.description || "",
            image: normalizedThumbnail || rawThumbnail || coldImg,
          };
        });

        if (isMounted) {
          setEvents(mapped);
        }
      } catch (error) {
        console.error("Failed to load events", error);
      }
    };

    loadEvents();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="upcoming-carousel-container">
      <h2 className="carousel-title">Upcoming Experiences</h2>
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={30}
        slidesPerView={3}
        loop={true}
        navigation
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
          reverseDirection: false,
        }}
        breakpoints={{
          320: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {events.map((event, idx) => (
          <SwiperSlide key={idx}>
            <div
              className="event-cards"
              onClick={() => navigate(`/Singleeventdetails/${event.id || ""}`)}
              style={{ cursor: "pointer" }}
            >
              <div className="card-header">
                <div style={{ textAlign: "center" }}>
                  <div className="eventdate">
                    <span className="eventday">{event.date}</span>
                    <span className="event-month">{event.month}</span>
                  </div>
                  <div className="event-title">{event.title}</div>
                </div>
                <div className="card-image-wrapper">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="event-image"
                  />
                </div>
              </div>
              <div className="event-meta">
                <span className="event-city">{event.city}</span>
                <span className="eventtime">{event.time}</span>
              </div>
              <div className="event-description">{event.description}</div>
              <div className="event-arrow">
                <img src={arrowImg} alt="" className="event-arrow-image" />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <button
        className="see-all-btn"
        type="button"
        onClick={() => navigate("/events")}
      >
        See All Events
      </button>
    </div>
  );
};

export default Upcommingexprences;
